import { useEffect, useState } from 'react';

interface Props {
  title: string;
  subtitle: string;
  tag?: string;
  imageSrc: string;
  imageAlt: string;
}

export default function PageHero({ title, subtitle, tag, imageSrc, imageAlt }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/20" />
      </div>

      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-32 bg-gradient-to-b from-transparent via-gold to-transparent hidden lg:block" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-36 pb-24">
        <div className="max-w-2xl">
          <div
            className="flex items-center gap-3 mb-7"
            style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(16px)', transition: 'all 0.6s ease' }}
          >
            <span className="gold-line" />
            <span className="section-tag text-gold">{tag || 'Value Carpet Inc · Freehold, NJ'}</span>
          </div>
          <h1
            className="font-serif text-5xl lg:text-6xl text-white leading-[1.08] mb-7"
            style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(24px)', transition: 'all 0.75s ease 0.1s' }}
          >
            {title}
          </h1>
          <p
            className="text-white/70 text-lg leading-relaxed mb-10 max-w-lg"
            style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)', transition: 'all 0.75s ease 0.2s' }}
          >
            {subtitle}
          </p>
          <div
            className="flex flex-col sm:flex-row gap-4"
            style={{ opacity: visible ? 1 : 0, transition: 'all 0.75s ease 0.3s' }}
          >
            <button onClick={scrollToContact} className="btn-primary text-base">
              Request a Consultation
            </button>
            <a href="tel:1-866-732-2966" className="btn-secondary text-base flex items-center justify-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill"></i>
              </span>
              Call Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
